export class MsrValueApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getValues() {
    return this.#http.get('/msrValue');
  }

  async createValue(body) {
    return this.#http.post('/msrValue', body);
  }

  async editValue({ msrValueId, ...body }) {
    return this.#http.put(`/msrValue/${msrValueId}`, body);
  }

  async deleteValue({ msrValueId }) {
    return this.#http.delete(`/msrValue/${msrValueId}`);
  }
}
